module.exports = "/* .row:nth-child(odd){\r\n    background: #ececec;   \r\n} */\r\n\r\n/* .row{\r\n    padding: 1em 0px 0px 0px !important;\r\n} */\r\n\r\n.mat-form-field-wrapper{\r\n    padding-bottom:0px !important;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #ececec;\r\n}\r\n\r\n.row{\r\n    padding:9px 0px 0px !important;\r\n}\r\n\r\n.error-msg{\r\n    margin-top:-4px;\r\n}\r\n\r\n.input-group label{\r\n    width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/change-password/change-password.component.css
// module id = ./src/app/ultilities/change-password/change-password.component.css
// module chunks = main